import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, tap } from 'rxjs';

import { environment } from '@fantaz/shared/app-config';
import { BEConfig } from '@fantaz/shared/data-access/models';

@Injectable({
  providedIn: 'root',
})
export class ConfigApiService {
  private beConfig: BEConfig;

  constructor(private http: HttpClient) {}

  loadConfig(): Observable<BEConfig> {
    return this.http
      .get<BEConfig>(`${environment.apiBaseUrl}/api/public/config`)
      .pipe(
        tap((config) => {
          this.beConfig = config;
        }),
      );
  }

  getDepositFee() {
    return this.beConfig?.depositFee || 0;
  }

  getWithdrawalFee() {
    return this.beConfig?.withdrawalFee || 0;
  }

  getBlockedCashPlayStates() {
    return this.beConfig?.blockedCashPlayStates || [];
  }

  isTSEVODisabled() {
    return this.beConfig?.TSEVO_DISABLED || false;
  }

  isEcheckEarlyDepositAllowed() {
    return Number(this.beConfig?.ECHECK_EARLY_DEPOSIT_AMOUNT || 0) > 0;
  }

  isACHEnabled(): boolean {
    const methods = this.beConfig?.PAYMENT_METHODS;
    if (methods && methods.length > 0) {
      return methods.some((m) => m.method === 'ACH' && m.enabled);
    }
    return this.isEcheckEarlyDepositAllowed();
  }

  isCCEnabled(): boolean {
    const methods = this.beConfig?.PAYMENT_METHODS;
    if (methods && methods.length > 0) {
      return methods.some((m) => m.method === 'CC' && m.enabled);
    }
    return true;
  }

  getEnabledCCTypes(): string[] | null {
    const methods = this.beConfig?.PAYMENT_METHODS;
    if (methods && methods.length > 0) {
      const cc = methods.find((m) => m.method === 'CC' && m.enabled);
      return cc?.types?.map((t) => t.toLowerCase()) ?? null;
    }
    return null;
  }

  getEnabledPaymentMethods(): Record<string, true | string[]> {
    const achEnabled = this.isACHEnabled();
    const ccEnabled = this.isCCEnabled();
    const ccTypes = this.getEnabledCCTypes();

    return {
      ...(ccEnabled ? { CC: ccTypes ?? true } : {}),
      ...(achEnabled ? { ACH: true } : {}),
    };
  }

  getDaysToCancelApprovedRequests() {
    return this.beConfig?.daysToCancelApprovedRequests || 7;
  }
}
